// Textos dos Imóveis da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
// `farm.ficha.*` são as peças que Imóveis, Documentos e Fundo dividem: o eyebrow do
// Topbar, o botão de planilha e o vazio da ficha.
const pt = {
  'farm.ficha.eyebrow': 'Fazendas',
  'farm.ficha.excel': 'Excel',
  'farm.ficha.naoInformado': 'Não informado',

  'farm.imoveis.titulo': 'Imóveis',
  'farm.imoveis.ajuda': 'Todos os imóveis do grupo, com ou sem movimento. Os indicadores filtram a lista; clique de novo para limpar. Abra um imóvel para ver os dados, as matrículas, o desenho, os documentos, a equipe e a agenda dele.',
  'farm.imoveis.busca': 'Buscar por nome, município ou gerente',
  'farm.imoveis.semResultado': 'Nenhum imóvel com estes filtros',
  'farm.imoveis.novo': 'Novo imóvel',
  'farm.imoveis.editar': 'Editar',
  'farm.imoveis.todas': 'Todas',
  'farm.imoveis.marca': 'Marca',
  'farm.imoveis.car': 'CAR',
  'farm.imoveis.carSituacao': 'CAR {{situacao}}',
  'farm.imoveis.vista': 'Vista',
  'farm.imoveis.vistaCartoes': 'Ver em cartões',
  'farm.imoveis.vistaLista': 'Ver em lista',
  'farm.imoveis.abrir': 'Abrir {{nome}}',
  'farm.imoveis.abrirDetalhe': 'Abrir o imóvel',
  'farm.imoveis.abrirNoMapa': 'Abrir no mapa',
  'farm.imoveis.voltarALista': 'Voltar aos imóveis',
  'farm.imoveis.hectares': '{{n}} ha',
  'farm.imoveis.matriculasN': 'Matrículas {{n}}',
  'farm.imoveis.documentosN': 'Documentos {{n}}',
  'farm.imoveis.aVencerN': '{{n}} a vencer',
  'farm.imoveis.vencidosN': 'Vencidos {{n}}',

  'farm.imoveis.kpi.fundo': 'Do fundo',
  'farm.imoveis.kpi.proprios': 'Próprios',
  'farm.imoveis.kpi.arrendados': 'Arrendados',
  'farm.imoveis.kpi.car': 'CAR pendente',
  'farm.imoveis.kpi.documentos': 'Documento a vencer',
  'farm.imoveis.kpi.area': 'Área total',
  'farm.imoveis.kpi.areaDica': 'Soma das áreas de {{n}} imóveis',

  'farm.imoveis.col.imovel': 'Imóvel',
  'farm.imoveis.col.atividade': 'Atividade',
  'farm.imoveis.col.area': 'Área',
  'farm.imoveis.col.gerente': 'Gerente',
  'farm.imoveis.col.acoes': 'Ações',

  'farm.imoveis.aba.dados': 'Dados',
  'farm.imoveis.aba.matriculas': 'Matrículas',
  'farm.imoveis.aba.mapa': 'Mapa',
  'farm.imoveis.aba.documentos': 'Documentos',
  'farm.imoveis.aba.equipe': 'Equipe',
  'farm.imoveis.aba.agenda': 'Agenda',

  'farm.imoveis.detalhe.subtitulo': '{{tipo}} em {{municipio}}, {{uf}}',
  'farm.imoveis.detalhe.matriculas': 'Matrículas',
  'farm.imoveis.detalhe.glebas': 'Glebas',
  'farm.imoveis.detalhe.documentos': 'Documentos',
  'farm.imoveis.semDesenho': 'O desenho deste imóvel entra com o CAR',
  'farm.imoveis.semEquipe': 'Ninguém do quadro ligado a este imóvel ainda',
  'farm.imoveis.semAgenda': 'Nenhuma obrigação para este imóvel ainda',

  'farm.imoveis.dados.fundo': 'Fundo',
  'farm.imoveis.dados.googleMaps': 'Google Maps',
  'farm.imoveis.dados.somaMatriculas': 'Soma das matrículas',

  'farm.imoveis.matriculas.col.matricula': 'Matrícula',
  'farm.imoveis.matriculas.col.proprietario': 'Proprietário',
  'farm.imoveis.matriculas.col.documento': 'Documento',
  'farm.imoveis.matriculas.fatia': '{{n}}% do imóvel',
  'farm.imoveis.matriculas.soma': 'Matrículas somam {{soma}} ha de {{total}} ha',
  'farm.imoveis.matriculas.vazio': 'Nenhuma matrícula cadastrada',

  'farm.imoveis.form.editar': 'Editar {{nome}}',
  'farm.imoveis.form.identificacao': 'Identificação',
  'farm.imoveis.form.localizacao': 'Localização e área',
  'farm.imoveis.form.gerente': 'Gerente',
  'farm.imoveis.form.observacoes': 'Observações',
  'farm.imoveis.form.nome': 'Nome',
  'farm.imoveis.form.apelido': 'Apelido',
  'farm.imoveis.form.tipo': 'Tipo',
  'farm.imoveis.form.situacao': 'Situação',
  'farm.imoveis.form.adquiridoEm': 'Ano de aquisição',
  'farm.imoveis.form.municipio': 'Município',
  'farm.imoveis.form.uf': 'UF',
  'farm.imoveis.form.latitude': 'Latitude',
  'farm.imoveis.form.longitude': 'Longitude',
  'farm.imoveis.form.hectares': 'Área total em hectares',
  'farm.imoveis.form.carNumero': 'Número do recibo do CAR',
  'farm.imoveis.form.carSituacao': 'Situação do CAR',
  'farm.imoveis.form.gerenteNome': 'Nome do gerente',
  'farm.imoveis.form.telefone': 'Telefone',
  'farm.imoveis.form.email': 'E-mail',
  'farm.imoveis.form.naoSalvo': 'Não salvo',
  'farm.imoveis.form.criado': 'Imóvel cadastrado',
  'farm.imoveis.form.salvo': 'Imóvel salvo',
  'farm.imoveis.form.sairTitulo': 'Sair sem salvar?',
  'farm.imoveis.form.sairTexto': 'As alterações deste imóvel ainda não foram salvas.',
  'farm.imoveis.form.sair': 'Sair sem salvar',
  'farm.imoveis.form.ficar': 'Continuar editando',

  'farm.imoveis.erro.nome': 'Informe o nome',
  'farm.imoveis.erro.apelido': 'Informe o apelido',
  'farm.imoveis.erro.tipo': 'Escolha o tipo',
  'farm.imoveis.erro.atividade': 'Escolha a atividade',
  'farm.imoveis.erro.situacao': 'Escolha a situação',
  'farm.imoveis.erro.municipio': 'Informe o município',
  'farm.imoveis.erro.uf': 'Escolha a UF',
  'farm.imoveis.erro.latitude': 'Latitude inválida',
  'farm.imoveis.erro.longitude': 'Longitude inválida',
  'farm.imoveis.erro.hectares': 'Informe a área',
  'farm.imoveis.erro.car': 'Informe o número do CAR',
  'farm.imoveis.erro.carSituacao': 'Escolha a situação do CAR',
  'farm.imoveis.erro.email': 'E-mail inválido',
  'farm.imoveis.erro.ano': 'Ano inválido',
}

const en: typeof pt = {
  'farm.ficha.eyebrow': 'Farms',
  'farm.ficha.excel': 'Excel',
  'farm.ficha.naoInformado': 'Not provided',

  'farm.imoveis.titulo': 'Properties',
  'farm.imoveis.ajuda': 'Every property of the group, active or not. The indicators filter the list; click again to clear. Open a property to see its data, title deeds, drawing, documents, team and agenda.',
  'farm.imoveis.busca': 'Search by name, city or manager',
  'farm.imoveis.semResultado': 'No property with these filters',
  'farm.imoveis.novo': 'New property',
  'farm.imoveis.editar': 'Edit',
  'farm.imoveis.todas': 'All',
  'farm.imoveis.marca': 'Brand',
  'farm.imoveis.car': 'CAR',
  'farm.imoveis.carSituacao': 'CAR {{situacao}}',
  'farm.imoveis.vista': 'View',
  'farm.imoveis.vistaCartoes': 'Card view',
  'farm.imoveis.vistaLista': 'List view',
  'farm.imoveis.abrir': 'Open {{nome}}',
  'farm.imoveis.abrirDetalhe': 'Open the property',
  'farm.imoveis.abrirNoMapa': 'Open on the map',
  'farm.imoveis.voltarALista': 'Back to properties',
  'farm.imoveis.hectares': '{{n}} ha',
  'farm.imoveis.matriculasN': 'Title deeds {{n}}',
  'farm.imoveis.documentosN': 'Documents {{n}}',
  'farm.imoveis.aVencerN': '{{n}} expiring',
  'farm.imoveis.vencidosN': 'Expired {{n}}',

  'farm.imoveis.kpi.fundo': 'Fund owned',
  'farm.imoveis.kpi.proprios': 'Owned',
  'farm.imoveis.kpi.arrendados': 'Leased out',
  'farm.imoveis.kpi.car': 'CAR pending',
  'farm.imoveis.kpi.documentos': 'Document expiring',
  'farm.imoveis.kpi.area': 'Total area',
  'farm.imoveis.kpi.areaDica': 'Sum of the areas of {{n}} properties',

  'farm.imoveis.col.imovel': 'Property',
  'farm.imoveis.col.atividade': 'Activity',
  'farm.imoveis.col.area': 'Area',
  'farm.imoveis.col.gerente': 'Manager',
  'farm.imoveis.col.acoes': 'Actions',

  'farm.imoveis.aba.dados': 'Data',
  'farm.imoveis.aba.matriculas': 'Title deeds',
  'farm.imoveis.aba.mapa': 'Map',
  'farm.imoveis.aba.documentos': 'Documents',
  'farm.imoveis.aba.equipe': 'Team',
  'farm.imoveis.aba.agenda': 'Agenda',

  'farm.imoveis.detalhe.subtitulo': '{{tipo}} in {{municipio}}, {{uf}}',
  'farm.imoveis.detalhe.matriculas': 'Title deeds',
  'farm.imoveis.detalhe.glebas': 'Plots',
  'farm.imoveis.detalhe.documentos': 'Documents',
  'farm.imoveis.semDesenho': 'The drawing of this property comes with the CAR',
  'farm.imoveis.semEquipe': 'No one on staff linked to this property yet',
  'farm.imoveis.semAgenda': 'No obligation for this property yet',

  'farm.imoveis.dados.fundo': 'Fund',
  'farm.imoveis.dados.googleMaps': 'Google Maps',
  'farm.imoveis.dados.somaMatriculas': 'Sum of title deeds',

  'farm.imoveis.matriculas.col.matricula': 'Title deed',
  'farm.imoveis.matriculas.col.proprietario': 'Owner',
  'farm.imoveis.matriculas.col.documento': 'Document',
  'farm.imoveis.matriculas.fatia': '{{n}}% of the property',
  'farm.imoveis.matriculas.soma': 'Title deeds add up to {{soma}} ha of {{total}} ha',
  'farm.imoveis.matriculas.vazio': 'No title deed registered',

  'farm.imoveis.form.editar': 'Edit {{nome}}',
  'farm.imoveis.form.identificacao': 'Identification',
  'farm.imoveis.form.localizacao': 'Location and area',
  'farm.imoveis.form.gerente': 'Manager',
  'farm.imoveis.form.observacoes': 'Notes',
  'farm.imoveis.form.nome': 'Name',
  'farm.imoveis.form.apelido': 'Short name',
  'farm.imoveis.form.tipo': 'Type',
  'farm.imoveis.form.situacao': 'Ownership',
  'farm.imoveis.form.adquiridoEm': 'Year acquired',
  'farm.imoveis.form.municipio': 'City',
  'farm.imoveis.form.uf': 'State',
  'farm.imoveis.form.latitude': 'Latitude',
  'farm.imoveis.form.longitude': 'Longitude',
  'farm.imoveis.form.hectares': 'Total area in hectares',
  'farm.imoveis.form.carNumero': 'CAR receipt number',
  'farm.imoveis.form.carSituacao': 'CAR status',
  'farm.imoveis.form.gerenteNome': 'Manager name',
  'farm.imoveis.form.telefone': 'Phone',
  'farm.imoveis.form.email': 'Email',
  'farm.imoveis.form.naoSalvo': 'Not saved',
  'farm.imoveis.form.criado': 'Property registered',
  'farm.imoveis.form.salvo': 'Property saved',
  'farm.imoveis.form.sairTitulo': 'Leave without saving?',
  'farm.imoveis.form.sairTexto': 'The changes to this property have not been saved.',
  'farm.imoveis.form.sair': 'Leave without saving',
  'farm.imoveis.form.ficar': 'Keep editing',

  'farm.imoveis.erro.nome': 'Enter the name',
  'farm.imoveis.erro.apelido': 'Enter the short name',
  'farm.imoveis.erro.tipo': 'Choose the type',
  'farm.imoveis.erro.atividade': 'Choose the activity',
  'farm.imoveis.erro.situacao': 'Choose the ownership',
  'farm.imoveis.erro.municipio': 'Enter the city',
  'farm.imoveis.erro.uf': 'Choose the state',
  'farm.imoveis.erro.latitude': 'Invalid latitude',
  'farm.imoveis.erro.longitude': 'Invalid longitude',
  'farm.imoveis.erro.hectares': 'Enter the area',
  'farm.imoveis.erro.car': 'Enter the CAR number',
  'farm.imoveis.erro.carSituacao': 'Choose the CAR status',
  'farm.imoveis.erro.email': 'Invalid email',
  'farm.imoveis.erro.ano': 'Invalid year',
}

const es: typeof pt = {
  'farm.ficha.eyebrow': 'Haciendas',
  'farm.ficha.excel': 'Excel',
  'farm.ficha.naoInformado': 'No informado',

  'farm.imoveis.titulo': 'Inmuebles',
  'farm.imoveis.ajuda': 'Todos los inmuebles del grupo, con o sin movimiento. Los indicadores filtran la lista; haga clic de nuevo para limpiar. Abra un inmueble para ver sus datos, matrículas, dibujo, documentos, equipo y agenda.',
  'farm.imoveis.busca': 'Buscar por nombre, municipio o gerente',
  'farm.imoveis.semResultado': 'Ningún inmueble con estos filtros',
  'farm.imoveis.novo': 'Nuevo inmueble',
  'farm.imoveis.editar': 'Editar',
  'farm.imoveis.todas': 'Todas',
  'farm.imoveis.marca': 'Marca',
  'farm.imoveis.car': 'CAR',
  'farm.imoveis.carSituacao': 'CAR {{situacao}}',
  'farm.imoveis.vista': 'Vista',
  'farm.imoveis.vistaCartoes': 'Ver en tarjetas',
  'farm.imoveis.vistaLista': 'Ver en lista',
  'farm.imoveis.abrir': 'Abrir {{nome}}',
  'farm.imoveis.abrirDetalhe': 'Abrir el inmueble',
  'farm.imoveis.abrirNoMapa': 'Abrir en el mapa',
  'farm.imoveis.voltarALista': 'Volver a los inmuebles',
  'farm.imoveis.hectares': '{{n}} ha',
  'farm.imoveis.matriculasN': 'Matrículas {{n}}',
  'farm.imoveis.documentosN': 'Documentos {{n}}',
  'farm.imoveis.aVencerN': '{{n}} por vencer',
  'farm.imoveis.vencidosN': 'Vencidos {{n}}',

  'farm.imoveis.kpi.fundo': 'Del fondo',
  'farm.imoveis.kpi.proprios': 'Propios',
  'farm.imoveis.kpi.arrendados': 'Arrendados',
  'farm.imoveis.kpi.car': 'CAR pendiente',
  'farm.imoveis.kpi.documentos': 'Documento por vencer',
  'farm.imoveis.kpi.area': 'Área total',
  'farm.imoveis.kpi.areaDica': 'Suma de las áreas de {{n}} inmuebles',

  'farm.imoveis.col.imovel': 'Inmueble',
  'farm.imoveis.col.atividade': 'Actividad',
  'farm.imoveis.col.area': 'Área',
  'farm.imoveis.col.gerente': 'Gerente',
  'farm.imoveis.col.acoes': 'Acciones',

  'farm.imoveis.aba.dados': 'Datos',
  'farm.imoveis.aba.matriculas': 'Matrículas',
  'farm.imoveis.aba.mapa': 'Mapa',
  'farm.imoveis.aba.documentos': 'Documentos',
  'farm.imoveis.aba.equipe': 'Equipo',
  'farm.imoveis.aba.agenda': 'Agenda',

  'farm.imoveis.detalhe.subtitulo': '{{tipo}} en {{municipio}}, {{uf}}',
  'farm.imoveis.detalhe.matriculas': 'Matrículas',
  'farm.imoveis.detalhe.glebas': 'Parcelas',
  'farm.imoveis.detalhe.documentos': 'Documentos',
  'farm.imoveis.semDesenho': 'El dibujo de este inmueble llega con el CAR',
  'farm.imoveis.semEquipe': 'Nadie del personal vinculado a este inmueble todavía',
  'farm.imoveis.semAgenda': 'Ninguna obligación para este inmueble todavía',

  'farm.imoveis.dados.fundo': 'Fondo',
  'farm.imoveis.dados.googleMaps': 'Google Maps',
  'farm.imoveis.dados.somaMatriculas': 'Suma de las matrículas',

  'farm.imoveis.matriculas.col.matricula': 'Matrícula',
  'farm.imoveis.matriculas.col.proprietario': 'Propietario',
  'farm.imoveis.matriculas.col.documento': 'Documento',
  'farm.imoveis.matriculas.fatia': '{{n}}% del inmueble',
  'farm.imoveis.matriculas.soma': 'Las matrículas suman {{soma}} ha de {{total}} ha',
  'farm.imoveis.matriculas.vazio': 'Ninguna matrícula registrada',

  'farm.imoveis.form.editar': 'Editar {{nome}}',
  'farm.imoveis.form.identificacao': 'Identificación',
  'farm.imoveis.form.localizacao': 'Ubicación y área',
  'farm.imoveis.form.gerente': 'Gerente',
  'farm.imoveis.form.observacoes': 'Observaciones',
  'farm.imoveis.form.nome': 'Nombre',
  'farm.imoveis.form.apelido': 'Nombre corto',
  'farm.imoveis.form.tipo': 'Tipo',
  'farm.imoveis.form.situacao': 'Situación',
  'farm.imoveis.form.adquiridoEm': 'Año de adquisición',
  'farm.imoveis.form.municipio': 'Municipio',
  'farm.imoveis.form.uf': 'Estado',
  'farm.imoveis.form.latitude': 'Latitud',
  'farm.imoveis.form.longitude': 'Longitud',
  'farm.imoveis.form.hectares': 'Área total en hectáreas',
  'farm.imoveis.form.carNumero': 'Número del recibo del CAR',
  'farm.imoveis.form.carSituacao': 'Situación del CAR',
  'farm.imoveis.form.gerenteNome': 'Nombre del gerente',
  'farm.imoveis.form.telefone': 'Teléfono',
  'farm.imoveis.form.email': 'Correo',
  'farm.imoveis.form.naoSalvo': 'No guardado',
  'farm.imoveis.form.criado': 'Inmueble registrado',
  'farm.imoveis.form.salvo': 'Inmueble guardado',
  'farm.imoveis.form.sairTitulo': '¿Salir sin guardar?',
  'farm.imoveis.form.sairTexto': 'Los cambios de este inmueble todavía no se guardaron.',
  'farm.imoveis.form.sair': 'Salir sin guardar',
  'farm.imoveis.form.ficar': 'Seguir editando',

  'farm.imoveis.erro.nome': 'Informe el nombre',
  'farm.imoveis.erro.apelido': 'Informe el nombre corto',
  'farm.imoveis.erro.tipo': 'Elija el tipo',
  'farm.imoveis.erro.atividade': 'Elija la actividad',
  'farm.imoveis.erro.situacao': 'Elija la situación',
  'farm.imoveis.erro.municipio': 'Informe el municipio',
  'farm.imoveis.erro.uf': 'Elija el estado',
  'farm.imoveis.erro.latitude': 'Latitud inválida',
  'farm.imoveis.erro.longitude': 'Longitud inválida',
  'farm.imoveis.erro.hectares': 'Informe el área',
  'farm.imoveis.erro.car': 'Informe el número del CAR',
  'farm.imoveis.erro.carSituacao': 'Elija la situación del CAR',
  'farm.imoveis.erro.email': 'Correo inválido',
  'farm.imoveis.erro.ano': 'Año inválido',
}

export default { pt, en, es }
